"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalInvestorFormSchema = exports.SOURCE_OF_FUNDS_REQUIRED = exports.SOURCE_OF_FUNDS_MAX_LENGTH = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../contracts/enums");
const IndividualShareholder_1 = require("./IndividualShareholder");
const DistributionProfile_1 = require("./DistributionProfile");
const MAX_FILE_SIZE = 5242880; // 5MB in bytes
const validFileExtensions = ["pdf"]; // For checking extensions
exports.SOURCE_OF_FUNDS_MAX_LENGTH = 1000;
exports.SOURCE_OF_FUNDS_REQUIRED = "Source of funds is required";
const isValidFileExtension = (file) => {
    const extension = file.name.split(".").pop().toLowerCase();
    return validFileExtensions.includes(extension);
};
exports.ExternalInvestorFormSchema = IndividualShareholder_1.ShareholderFormSchema.shape({
    investorType: yup.string().default(enums_1.InvestorType.SOPHISTICATED),
    investorCertificate: yup
        .mixed()
        .test("is-valid-type", "Not a valid PDF type", (file) => !file || file.type.toLowerCase() === "application/pdf")
        .test("is-valid-extension", "Not a valid PDF file", (file) => {
        if (!file)
            return true;
        return isValidFileExtension(file);
    })
        .test("is-valid-size", "Maximum file size allowed is 5MB", (file) => !file || file.size <= MAX_FILE_SIZE),
    certificateExpiryDate: yup.date().nullable().notRequired(),
    // Required only when the application-updates flag is on, so the flag-off schema is unchanged.
    sourceOfFunds: yup
        .string()
        .trim()
        .max(exports.SOURCE_OF_FUNDS_MAX_LENGTH, `Source of funds must be at most ${exports.SOURCE_OF_FUNDS_MAX_LENGTH} characters`)
        .when("$requireSourceOfFunds", ([requireSourceOfFunds], schema) => requireSourceOfFunds ? schema.required(exports.SOURCE_OF_FUNDS_REQUIRED) : schema.optional()),
    classDistributionPreferences: yup
        .array()
        .of(yup.object({ unitClassId: yup.string().optional(), preference: yup.string().optional() }))
        .default(undefined),
}).concat(DistributionProfile_1.DistributionProfileSchema);
//# sourceMappingURL=ExternalInvestorSchema.js.map